<template>
<v-app>
    <v-snackbar v-model="snackbar" top color="red" :timeout="4000">
        {{ errorMsg }}
        <v-btn color="white" icon @click="snackbar = false">
            <v-icon>mdi-close</v-icon>
        </v-btn>
    </v-snackbar>
    <v-container fluid class="mt-1">
        <v-card class="mx-10">
            <v-card-title>
              <v-img style="max-width: 250px" src="@/assets/logo-bmci.png"></v-img>
                <v-spacer></v-spacer>
                LOA TAUX 0% Particuliers
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col>
                        <v-simple-table dense>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">Apport (%)</th>
                                        <th class="text-left">Nbre loyers</th>
                                        <th class="text-left">Loyer TTC (Y compris Ass DIT)</th>
                                        <th class="text-left">Apport Client TTC (Y compris FD & Ass DIT)</th>
                                        <th class="text-left">Ass DIT</th>
                                        <th class="text-left">Coût Global TTC(Hors Ass DIT)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="offre in offres">
                                        <tr :key="offre.id" v-if="offre.niveauApport == selectedApport">
                                            <td class="text-right">{{offre.niveauApport}} %</td>
                                            <td class="text-right">{{offre.duree}}</td>
                                            <td class="text-right">{{FormatPrix(CalculeLoyerWithAssDit(offre))}}</td>
                                            <td class="text-right">{{FormatPrix(CalculeApport(offre))}}</td>
                                            <td class="text-right">{{FormatPrix(CalculeAssDit(offre))}}</td>
                                            <td class="text-right">{{FormatPrix(CalculeCoutGlobal(offre))}}</td>
                                        </tr>
                                    </template>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</v-app>
</template>

<script>
export default {
    name: 'LoaBmciTx0Particuliers',
    data() {
        return {
            offres: [],
            snackbar: false,
            errorMsg: ''
        }
    },
    mounted() {
        this.getOffres()
    },
    methods: {
        getOffres: function () {
            let params = {}
            params.action = 'getOffres'
            params.type = 'bmci'
            params.name = 'loatx0particuliers'
            this.axios.post(this.$store.state.rootUrl + 'apiSalesTarifier.php', params)
                .then(data => {
                    this.offres = data.data
                })
                .catch(error => {
                    this.errorMsg = 'Oups Erreur Serveur. Veuillez réessayer dans quelques instants'
                    this.snackbar = true
                    console.log(error)
                })
        },
        CalculeAssDit: function (offre) {
            let AssDit = (this.montant * (1 - (offre.niveauApport / 100))) * (0.06 / 100) * 1.1
            return AssDit.toFixed(2)
        },
        CalculeLoyerWithAssDit: function (offre) {
            let value = (((this.montant * (1 - (offre.niveauApport / 100)))) / offre.duree) + ((this.montant * (1 - (offre.niveauApport / 100))) * (0.06 / 100) * 1.1)
            return value.toFixed(2)
        },
        CalculeApport: function (offre) {
            let value = (this.montant * (offre.niveauApport / 100)) + ((this.montant * (1 - (offre.niveauApport / 100))) * (0.06 / 100) * 1.1) + (this.montant * offre.fd)
            return value.toFixed(2)
        },
        CalculeCoutGlobal: function (offre) {
            let value = this.montant * offre.fd
            return value.toFixed(2)
        },
        FormatPrix: function (prix) {
            return new Intl.NumberFormat('de-DE', {
                style: 'decimal',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(prix)
        }
    },
    computed: {
        montant() {
            return this.$store.state.simulateur.montant
        },
        selectedApport() {
            return this.$store.state.simulateur.selectedApport
        }
    }
}
</script>
